/**
 * External dependencies
 */
import { Link } from 'gatsby';
import React from 'react';
import { Row, Col } from 'react-bootstrap';

/**
 * Internal dependencies
 */
import CustomSelect from '../custom-select/custom-select';
import './styles/_index.scss';

const sortOptions = [
    { value: 'Latest', label: 'Latest' },
    { value: 'Most Recent', label: 'Most Recent' },
];

const PropertyFilter = (props) => {
    return (
        <div className="property-filter" data-aos="fade-up">
            <div className="shell">
                <Row className="property-filter__row">
                    <Col className="property-filter__text">
                        <h4>Properties for sale in Sittingbourne</h4>
                        <p>{props.propertyCount} results found</p>
                    </Col>
                    <Col className="property-filter__actions">
                        <div className="property-filter__action location">
                            <i className="icon-location"></i>
                            <Link to="#" className="property-filter__label">View on a Map</Link>
                        </div>

                        <div className="property-filter__action">
                            <input type="checkbox" id="sold" name="sold" />
                            <label htmlFor="sold" className="property-filter__label">Include Sold</label>
                        </div>

                        <div className="property-filter__action sort">
                            <span className="property-filter__label">Sort: </span>
                            <CustomSelect placeholderValue="Most Recent" options={sortOptions} />
                        </div>
                    </Col>
                </Row>
            </div>
        </div>
    )
}

export default PropertyFilter;
